import apiClient from './apiClient';

export const locationService = {
  async getProvinces() {
    const response = await apiClient.get('/config/location/provinces');
    if (response && response.isSuccessful) {
      return response.listContent || response.content;
    }
    throw new Error(response?.message || 'Failed to retrieve provinces');
  },

  async getDistrictsByProvince(provinceId) {
    const response = await apiClient.get(`/config/location/district-by-province?province-id=${provinceId}`);
    if (response && response.isSuccessful) {
      return response.listContent || response.content;
    }
    throw new Error(response?.message || 'Failed to retrieve districts');
  }
};

export default locationService;
